import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: 'Votre importation est presque prête !',
      description: "Cliquez sur Continuer pour terminer l'importation",
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Certaines données de votre fichier sont manquantes ou ont un format incorrect',
      description:
        'Veuillez corriger les erreurs ci-dessous et re-télécharger le fichier, ou continuer pour ignorer les lignes/cellules invalides',
    },
    [ValidationStatus.Invalid]: {
      title: 'Le fichier téléchargé ne peut pas être traité',
      description: 'Veuillez corriger les erreurs ci-dessous et réessayer',
    },
  },
  sections: {
    heading_validation: {
      title: 'Incohérence de noms/ordre de colonnes détectée :',
      rules: {
        Exact: "La colonne #{{column}} doit être présente et s'appeler exactement <strong>{{expected}}</strong>",
      },
    },
    content_validation: {
      title: 'Erreurs détectées :',
      labels: {
        row: 'Ligne <strong>#{{row}} :</strong>',
        imported_rows_one: '{{count}} ligne sera importée',
        imported_rows_other: '{{count}} lignes seront importées',
        ignored_rows_one: '{{count}} ligne sera ignorée',
        ignored_rows_other: '{{count}} lignes seront ignorées',
      },
      fields: {
        email: 'E-mail',
        phone_number: 'Numéro de téléphone',
        first_name: 'Prénom',
        last_name: 'Nom',
        birthday: 'Date de naissance',
      },
      rules: {
        Required: 'Le champ {{field}} est obligatoire. La ligne sera ignorée',
        Email: 'Le champ {{field}} doit être une adresse e-mail valide. La ligne sera ignorée',
        Phone: 'Le champ {{field}} doit être un numéro de téléphone au format international. Le champ sera ignoré',
        Date: 'Le champ {{field}} doit être une date valide. Le champ sera ignoré',
      },
    },
  },
  buttons: {
    back_to_upload: 'Retour au téléchargement',
    proceed: 'Continuer',
  },
  toasts: {
    error: 'Une erreur est survenue, veuillez contacter le support',
  },
};
